import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { TranslateCourseRequest, TranslateCourseResponse } from './types';

export const translationsService = (client: AxiosInstance) => {
  const translateCourse = async (
    courseId: string,
    request: TranslateCourseRequest,
  ): Promise<TranslateCourseResponse> => {
    try {
      const result = await client.post<
        TranslateCourseResponse,
        AxiosResponse<TranslateCourseResponse>
      >(`translations/course/${courseId}`, request, {
        withCredentials: true,
      });
      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const translationsNotifyUrl = (courseId: string): string => {
    return `${client.defaults.baseURL}translations/notify/${courseId}`;
  };

  return {
    translateCourse,
    translationsNotifyUrl,
  };
};
